// Navigation store module for managing application steps

const state = {
  tabTitles: [],
  currentTabIndex: 0,
  isSubmitted: false,
};

const getters = {
  getCurrentTabIndex: (state) => state.currentTabIndex,
  getTabTitles: (state) => state.tabTitles,
  getStepIdFromIndex: (state) => (index) => state.tabTitles[Number(index)]?.id,
  getNextStepId: (state) => {
    const currentIndex = state.currentTabIndex;
    const nextIndex = currentIndex + 1;
    return nextIndex < state.tabTitles.length ? nextIndex : currentIndex;
  },
  getPreviousStepId: (state) => {
    const currentIndex = state.currentTabIndex;
    const prevIndex = currentIndex - 1;
    return prevIndex >= 0 ? prevIndex : currentIndex;
  },
};

const actions = {
  fetchStepsData({ commit, dispatch, rootState }) {
    return dispatch("Auth/fetchStepsData", null, { root: true }).then(
      (resp) => {
        const tabs = [];
        // Sort in reverse order
        for (let x = resp.length - 1; x >= 0; x--) {
          tabs.push({
            id: resp[x].admRegStepsId,
            orderCode: resp[x].stepNo,
            title: resp[x].stepTitle,
          });
        }
        // Add finished step
        tabs.push({
          id: 111,
          orderCode: Number(resp[0].stepNo) + 1,
          title: !localStorage.getItem("languageName")
            ? "النهاية"
            : localStorage.getItem("languageName") == "Ar"
            ? "النهاية"
            : "Finished",
        });
        commit("setTabTitles", tabs);

        // Restore previous navigation state if available
        dispatch("restoreNavigation");
      }
    );
  },

  changeTab({ commit, state }, index) {
    commit("setCurrentTabIndex", index);
    // Save to localStorage for persistence
    localStorage.setItem("stepId", state.tabTitles[index]?.id);
    localStorage.setItem("currentTabIndex", index);
  },

  nextStep({ dispatch, getters }) {
    dispatch("changeTab", getters.getNextStepId);
  },

  previousStep({ dispatch, getters }) {
    dispatch("changeTab", getters.getPreviousStepId);
  },

  restoreNavigation({ commit, state, rootState }) {
    const storedTabIndex = localStorage.getItem("currentTabIndex");
    if (storedTabIndex !== null) {
      commit("setCurrentTabIndex", parseInt(storedTabIndex));
    } else if (localStorage.getItem("stepId")) {
      const stepId = Number(localStorage.getItem("stepId"));
      const matchingTab = state.tabTitles.find((tab) => tab.id === stepId);
      if (matchingTab) {
        const index = state.tabTitles.indexOf(matchingTab);
        commit("setCurrentTabIndex", index);
      }
    }
  },
};

const mutations = {
  setTabTitles(state, tabTitles) {
    state.tabTitles = tabTitles;
  },
  setCurrentTabIndex(state, index) {
    state.currentTabIndex = index;
  },
  setIsSubmitted(state, isSubmitted) {
    state.isSubmitted = isSubmitted;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
